import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-download',
  templateUrl: './confirm-download.component.html',
  styleUrls: ['./confirm-download.component.scss'],
})
export class ConfirmDownloadComponent {
  language: string; // 'en' or 'ar'
  isDeadHead: boolean;
  isChecked: boolean;
  isLayoverTime: boolean;
  formData: {
    language: string;
    isDeadHead: boolean;
    isChecked: boolean;
    isLayoverTime: boolean;
  } = {
    language: 'en',
    isDeadHead: false,
    isChecked: true,
    isLayoverTime: false,
  };
  languages: { value: string; label: string }[] = [];
  constructor(
    public dialogRef: MatDialogRef<ConfirmDownloadComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      callbackMethod: (form: any) => void;
      type: string;
      module: string;
    }
  ) {
    this.language = 'en'; // Set the default language to 'en'
    this.isDeadHead = false; // Initialize checkboxes to false
    this.isChecked = true;
    this.isLayoverTime = false;
    switch (this.data.module) {
      case 'SALES':
        this.languages = this.getEN_AR();
        break;
      case 'FINANCE':
      case 'MSCR_ESCORT':
      case 'MSCR_FIRST_AID':
      case 'SALES_CONTRACT':
        this.languages = this.getEN();
        break;
      case 'MSCR_FLIGHT':
        this.languages = this.getENAR();
        break;
      default:
        break;
    }
  }

  onCancelClick(): void {
    this.dialogRef.close({ success: 'false' });
  }

  onSubmit() {
    // Handle form submission logic here
    if (this.data && this.data.callbackMethod) {
      this.data.callbackMethod(this.formData);
      this.dialogRef.close({ success: 'true' });
    }
  }

  getEN_AR() {
    return [
      { value: 'en', label: 'EN' },
      { value: 'en_ar', label: 'EN_AR' },
    ];
  }
  getEN() {
    return [{ value: 'en', label: 'EN' }];
  }
  getENAR() {
    return [
      { value: 'en', label: 'EN' },
      { value: 'ar', label: 'AR' },
    ];
  }
}
